interface GetGridParams {
  width: number;
  height: number;
  gapHorizontal: number;
  gapVertical: number;
}

export interface Grid {
  horizontalPositions: number[];
  verticalPositions: number[];
}

export const getGrid = ({
  width,
  height,
  gapHorizontal,
  gapVertical,
}: GetGridParams): Grid => {
  const horizontalPositions = getPositions(height, gapVertical);
  const verticalPositions = getPositions(width, gapHorizontal);

  return {
    horizontalPositions,
    verticalPositions,
  };
};

function getPositions(space: number, gap: number) {
  const center = space / 2;
  const halfLinesCount = Math.floor(center / gap);

  const positions = [];
  for (let i = -halfLinesCount; i <= halfLinesCount; i++) {
    positions.push(Math.floor(center + i * gap));
  }

  return positions;
}
